import callAPiBase from './base';

const heatMapChartApi = {
  get: ({ startDate, endDate }: { startDate: number, endDate: number }) =>
    callAPiBase({
      endpoint: `/api/reports/heatmap?startDate=${startDate}&endDate=${endDate}`,
      method: 'GET',
      useToken: true,
    }),
};

export { heatMapChartApi };
export default heatMapChartApi;
